import { render, staticRenderFns } from "./UploadExtension.vue?vue&type=template&id=dc5470d4"
import script from "./UploadExtension.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadExtension.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports